import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LoginFormComponent } from './login-form/login-form.component';
import { FeedbackListComponent } from './feedback-list/feedback-list.component';
import { TranslateModule } from '@ngx-translate/core';
import { SecondaryLogoComponent } from '../../components/shared/secondary-logo/secondary-logo.component';

@Component({
  selector: 'app-login-page',
  standalone: true,
  imports: [LoginFormComponent, FeedbackListComponent, TranslateModule, SecondaryLogoComponent],
  templateUrl: './login-page.component.html',
  styleUrl: './login-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginPageComponent {}
